import type { Component, ValidComponent } from "solid-js";
import { Dynamic } from "solid-js/web";
import { useSolidNodeView } from "./useSolidNodeView";

export type NodeViewWrapperProps = {
  [key: string]: unknown;
  ref?: HTMLDivElement | ((el: HTMLDivElement) => void);
  as?: ValidComponent;
};

export const NodeViewWrapper: Component<NodeViewWrapperProps> = (props) => {
  const { onDragStart } = useSolidNodeView();

  return (
    <Dynamic
      component={props.as ?? "div"}
      {...props}
      data-node-view-wrapper=""
      onDragStart={onDragStart}
      style={{
        ...(props.style ?? {}),
        "white-space": "normal",
      }}
    />
  );
};
